import axios from 'axios';
import ICard from "../models/card";
import {getSelectedSoGEnv, getSoGAPIBaseRoute} from "../common";

export default class SogApi {

    private static readonly HEADERS: {
        'Content-Type': 'application/x-www-form-urlencoded',
    };

    private static getAuthenticationData() {
        const formData = new URLSearchParams();
        formData.append('client_version', process.env.REACT_APP_SOGAPI_CLIENT_VERSION || "1.221");
        formData.append('username', process.env.REACT_APP_SOGAPI_USERNAME || "");
        formData.append('password', process.env.REACT_APP_SOGAPI_PASSWORD || "");
        return formData;
    }

    static async getAllCards(): Promise<Array<ICard>> {
        try {

            const formData = this.getAuthenticationData();
            formData.append('get_all_cards', '1');
            formData.append('action', 'get_all_cards');

            const response = await axios.post(
                getSoGAPIBaseRoute() + "get_all_cards",
                formData.toString(),
                {
                    headers: SogApi.HEADERS
                },
            );

            if (response.data?.status == "fail") {
                throw new Error(response.data?.message)
            }

            return response.data?.data?.cards;


        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    static async getUserCollection(username: string) {
        try {

            const formData = this.getAuthenticationData();
            formData.set("username", username)
            formData.append('get_collection_and_deck', '1');
            formData.append('action', 'get_collection_and_deck');

            getSelectedSoGEnv()
            const response = await axios.post(
                getSoGAPIBaseRoute() + "get_collection_and_deck",
                formData.toString(), {
                    headers: SogApi.HEADERS
                }
            );

            if (response.data?.status == "fail") {
                throw new Error(response.data?.message)
            }

            return response.data?.data?.collection;

        } catch (e) {
            console.error(e);
            throw e;
        }
    }

}
